import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button, Input, FormFeedback } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

import { selectCustomStyles } from "../../../common/selectCustomStyles";

const EvaluationModal = ({
  modal,
  toggle,
  isEdit,
  evaluation,
  courseUnits = [],
  semesters = [],
  onSubmit
}) => {

  // 🔹 Préparer les options pour react-select
  const courseUnitOptions = courseUnits.map(courseUnit => ({
    value: courseUnit.id,
    label: courseUnit.title
  }));

  // 🔹 Préparer les options pour react-select
  const semesterOptions = semesters.map(semester => ({
    value: semester.id,
    label: semester.code
  }));

  // 🔹 Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
        id: (evaluation && evaluation.id) || '',
        uuid: (evaluation && evaluation.uuid) || '',
        title: (evaluation && evaluation.title) || '',
        evaluation_type: (evaluation && evaluation.evaluation_type) || '',
        evaluation_date: (evaluation && evaluation.evaluation_date) || '',
        evaluation_time: (evaluation && evaluation.evaluation_time) || '',
        evaluation_semester_ids: evaluation?.semesters
        ? evaluation.semesters.map(s => s.id)
        : [],
        evaluation_course_unit_ids: evaluation?.course_units
        ? evaluation.course_units.map(s => s.id)
        : []
    },
    formikSchema: Yup.object({
        title: Yup.string().required("Veuillez saisir le titre"),
        evaluation_type: Yup.string().required("Veuillez sélectionner le type"),
        evaluation_date: Yup.string().required("Veuillez saisir la date"),
        evaluation_time: Yup.string().required("Veuillez saisir l'heure"),

        evaluation_semester_ids: Yup.array(),
        evaluation_course_unit_ids: Yup.array(),
    }).test(
        "semester-or-ue",
        "Sélectionnez au moins un semestre ou une UE",
        function (values) {
            const { evaluation_semester_ids, evaluation_course_unit_ids } = values;

            const hasSemester =
            Array.isArray(evaluation_semester_ids) &&
            evaluation_semester_ids.length > 0;

            const hasUE =
            Array.isArray(evaluation_course_unit_ids) &&
            evaluation_course_unit_ids.length > 0;

            return hasSemester || hasUE;
    }),
    onSubmit: values => {
      const payload = {
        ...values,
        evaluation_semester_ids: values.evaluation_semester_ids.map(Number),
        evaluation_course_unit_ids: values.evaluation_course_unit_ids.map(Number)
      };
      onSubmit(payload);
      //formik.resetForm();

      
    }
  });

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>
        {isEdit ? "Modifier - Évaluation" : "Ajouter - Évaluation"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
            <Row>
                <Col className="col-12">

                {/* Titre */}
                <div className="mb-3">
                    <Label>Titre</Label>
                    <Input
                    name="title"
                    type="text"
                    placeholder="Titre"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.title || ""}
                    invalid={formik.touched.title && !!formik.errors.title}
                    />
                    <FormFeedback>{formik.errors.title}</FormFeedback>
                </div>

                {/* Type */}
                <div className="mb-3">
                    <Label>Type</Label>
                    <Input
                    name="evaluation_type"
                    type="select"
                    value={formik.values.evaluation_type || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    invalid={formik.touched.evaluation_type && !!formik.errors.evaluation_type}
                    >
                    <option value="">Sélectionner</option>
                    <option value="CONTROL">Contrôle</option>
                    <option value="EXAM">Examen</option>
                    </Input>
                    <FormFeedback>{formik.errors.evaluation_type}</FormFeedback>
                </div>

                {/* Date */}
                <div className="mb-3">
                    <Label>Date</Label>
                    <Input
                    name="evaluation_date"
                    type="date"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.evaluation_date || ""}
                    invalid={formik.touched.evaluation_date && !!formik.errors.evaluation_date}
                    />
                    <FormFeedback>{formik.errors.evaluation_date}</FormFeedback>
                </div>

                {/* Heure */}
                <div className="mb-3">
                    <Label>Heure</Label>
                    <Input
                    name="evaluation_time"
                    type="time"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.evaluation_time || ""}
                    invalid={formik.touched.evaluation_time && !!formik.errors.evaluation_time}
                    />
                    <FormFeedback>{formik.errors.evaluation_time}</FormFeedback>
                </div>

                {/* Semestres */}
                <div className="mb-3">
                    <Label>Semestres</Label>
                    <Select
                    name="evaluation_semester_ids"
                    menuPortalTarget={null}
                    styles={selectCustomStyles}
                    options={semesterOptions}
                    isMulti
                    isDisabled={formik.values.evaluation_course_unit_ids.length > 0}
                    value={semesterOptions.filter(option =>
                        formik.values.evaluation_semester_ids.includes(option.value)
                    )}
                    onChange={(selected) => {
                        const values = selected ? selected.map(o => o.value) : [];
                        formik.setFieldValue("evaluation_semester_ids", values);

                        if (values.length > 0) {
                        formik.setFieldValue("evaluation_course_unit_ids", []);
                        }
                    }}
                    onBlur={() =>
                        formik.setFieldTouched("evaluation_semester_ids", true)
                    }
                    />
                    {formik.errors.evaluation_semester_ids && (
                    <div className="text-danger mt-1">
                        {formik.errors.evaluation_semester_ids}
                    </div>
                    )}
                </div>

                {/* UE */}
                <div className="mb-3">
                    <Label>Unités d’enseignement</Label>
                    <Select
                    name="evaluation_course_unit_ids"
                    menuPortalTarget={null}
                    styles={selectCustomStyles}
                    options={courseUnitOptions}
                    isMulti
                    isDisabled={formik.values.evaluation_semester_ids.length > 0}
                    value={courseUnitOptions.filter(option =>
                        formik.values.evaluation_course_unit_ids.includes(option.value)
                    )}
                    onChange={(selected) => {
                        const values = selected ? selected.map(o => o.value) : [];
                        formik.setFieldValue("evaluation_course_unit_ids", values);

                        if (values.length > 0) {
                        formik.setFieldValue("evaluation_semester_ids", []);
                        }
                    }}
                    onBlur={() =>
                        formik.setFieldTouched("evaluation_course_unit_ids", true)
                    }
                    />
                    {formik.errors.evaluation_course_unit_ids && (
                    <div className="text-danger mt-1">
                        {formik.errors.evaluation_course_unit_ids}
                    </div>
                    )}
                </div>

                </Col>
            </Row>

            <Row>
                <Col className="text-end">
                <Button type="submit" color="primary">
                    {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
                </Col>
            </Row>
        </form>

      </ModalBody>
    </Modal>
  );
};

export default EvaluationModal;
